import { render, staticRenderFns } from "./delPoint.vue?vue&type=template&id=168a3312&scoped=true"
import script from "./delPoint.vue?vue&type=script&lang=js"
export * from "./delPoint.vue?vue&type=script&lang=js"
import style0 from "./delPoint.vue?vue&type=style&index=0&id=168a3312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a3312",
  null
  
)

export default component.exports